import { useQuery } from '@tanstack/react-query';
import { dashboardKeys } from '@/lib/query-keys';
import { dashboardService } from '@/services/dashboard.service';

export function useDashboard() {
  const summaryQuery = useQuery({
    queryKey: dashboardKeys.summary(),
    queryFn: () => dashboardService.getSummary(),
  });

  const dealsFunnelQuery = useQuery({
    queryKey: dashboardKeys.dealsFunnel(),
    queryFn: () => dashboardService.getDealsFunnel(),
  });

  const revenueChartQuery = useQuery({
    queryKey: dashboardKeys.revenueChart(),
    queryFn: () => dashboardService.getRevenueChart(),
  });

  const leadSourcesQuery = useQuery({
    queryKey: dashboardKeys.leadSources(),
    queryFn: () => dashboardService.getLeadSources(),
  });

  const tasksOverviewQuery = useQuery({
    queryKey: dashboardKeys.tasksOverview(),
    queryFn: () => dashboardService.getTasksOverview(),
  });

  const recentActivitiesQuery = useQuery({
    queryKey: dashboardKeys.recentActivities(),
    queryFn: () => dashboardService.getRecentActivities(),
  });

  const topDealsQuery = useQuery({
    queryKey: dashboardKeys.topDeals(),
    queryFn: () => dashboardService.getTopDeals(),
  });

  return {
    summary: summaryQuery.data?.data,
    summaryLoading: summaryQuery.isLoading,
    dealsFunnel: dealsFunnelQuery.data?.data ?? [],
    dealsFunnelLoading: dealsFunnelQuery.isLoading,
    revenueChart: revenueChartQuery.data?.data ?? [],
    revenueChartLoading: revenueChartQuery.isLoading,
    leadSources: leadSourcesQuery.data?.data ?? [],
    leadSourcesLoading: leadSourcesQuery.isLoading,
    tasksOverview: tasksOverviewQuery.data?.data ?? [],
    tasksOverviewLoading: tasksOverviewQuery.isLoading,
    recentActivities: recentActivitiesQuery.data?.data ?? [],
    recentActivitiesLoading: recentActivitiesQuery.isLoading,
    topDeals: topDealsQuery.data?.data ?? [],
    topDealsLoading: topDealsQuery.isLoading,
  };
}
